import { Box, Heading, Text, Image } from '@chakra-ui/react';

export default function KsSectionTitle({ sectionContent,isFaq }) {
  const colors = { yellow: '#ECBD47', blue: '#081B5C', white: 'white' };
  return (
    <Box
      color={colors[sectionContent.titleColor]}
      textAlign={{ base: 'center', xl: sectionContent.titleDecoration==="sankalpa-flower"&&sectionContent.titleText==="Program Details"?'left':"center" }}
      py={{ base: '14px', md: '16px', lg: '15px' }}
      px={4}
      position="relative"
      mt="10px"
    >
      <Heading
        as="h1"
        w={{ base: '100%', md: '591px', xl: '100%' }}
        m={{ base: 'auto', xl: '0' }}
        fontSize={{ base: isFaq===true?"32px":'30px', md: isFaq===true?"28px":'38px',lg:sectionContent.titleDecoration==="sankalpa-flower"&&sectionContent.titleText==="Program Details"?"28px":isFaq===true?"28px":"38px", xl: isFaq===true?"46px":'44px' }}
        lineHeight={{ base: '40.32px', md: '47.88px', xl: '54px' }}
        fontWeight="700"
        fontFamily="Fedra Serif Display"
        letterSpacing="0.02em"
      >
        {sectionContent.titleText}
      </Heading>

      <Text
        fontSize={{ base: '20px', md: '24px' }}
        lineHeight={{ base: '32px', md: '30px' }}
        color={colors[sectionContent.titleColor]}
        fontWeight="400"
        mx="auto"
        fontFamily="Fedra Sans Std"
        mt={2}
        width={{ base: '95%', md: '100%' }}
        textAlign="center"
      >
        {sectionContent.titleSubtext}
      </Text>

      <Image
        src="https://www.datocms-assets.com/46272/1733201483-sankalpa-flower.png"
        alt="sankalpa-flower"
        w={{ base: '167px', md: '212px' }}
        h={{base:"25px",md:"33px"}}
        mt={{ base: '0px', md: '10px' }}
        pt={{base:"6px",md:''}}
      />
    </Box>
  );
}